export default __webpack_public_path__ + "static/media/image-53.555adc2e.png";